import { defineComponent as t, openBlock as r, createBlock as a, unref as c, mergeProps as l, withCtx as i, createElementVNode as p } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconNewConversationFilled",
  __name: "IconNewConversationFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (d, e) => (r(), a(c(s), l(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M12 3.25c1.155 0 2.055 0 2.782.045.733.045 1.34.14 1.903.35a6.25 6.25 0 0 1 3.67 3.67c.21.564.305 1.17.35 1.903C20.75 9.945 20.75 10.845 20.75 12v7.2c0 .128 0 .269-.01.39a1.3 1.3 0 0 1-.127.477 1.25 1.25 0 0 1-.546.546 1.3 1.3 0 0 1-.477.127c-.121.01-.262.01-.39.01H12c-1.155 0-2.055 0-2.782-.045-.733-.045-1.34-.14-1.903-.35a6.25 6.25 0 0 1-3.67-3.67c-.21-.563-.305-1.17-.35-1.903C3.25 14.055 3.25 13.155 3.25 12s0-2.055.045-2.782c.045-.733.14-1.34.35-1.903a6.25 6.25 0 0 1 3.67-3.67c.564-.21 1.17-.305 1.903-.35C9.945 3.25 10.845 3.25 12 3.25m0 4A.75.75 0 0 0 11.25 8v3.25H8a.75.75 0 0 0 0 1.5h3.25V16a.75.75 0 0 0 1.5 0v-3.25H16a.75.75 0 0 0 0-1.5h-3.25V8A.75.75 0 0 0 12 7.25",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
